import * as React from 'react';
import { TooltipDesktop, InlineText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IEscrowLabelTooltipProps {
  label: React.ReactElement;
}

export function EscrowLabelTooltip({ label }: IEscrowLabelTooltipProps) {
  return (
    <TooltipDesktop
      title={
        <div className={styles['tooltip']}>
          <InlineText2 color="white_100">Подробнее о эскроу–счёте</InlineText2>
        </div>
      }
    >
      {label}
    </TooltipDesktop>
  );
}
